import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { CASSubtype } from '../../../SubtypesTableContext'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'

export const useColumns = (): CIMSColumn<CASSubtype>[] => {
  return [
    useNameColumn({
      help: HelpMessage.CAS.SubTypes.Name,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Subtype'),
  ]
}
